export default __webpack_public_path__ + "static/media/malt-syrup.145751ac.jpg";